export default __webpack_public_path__ + "assets/message.6f94d7f2.svg";